import getLiveProgress from './get-live-progress';

export { getLiveProgress };

export default getLiveProgress;
